<!--
  ~ Copyright (C) 2026 DV Bern AG, Switzerland
  ~
  ~ This program is free software: you can redistribute it and/or modify
  ~ it under the terms of the GNU Affero General Public License as
  ~ published by the Free Software Foundation, either version 3 of the
  ~ License, or (at your option) any later version.
  ~
  ~ This program is distributed in the hope that it will be useful,
  ~ but WITHOUT ANY WARRANTY; without even the implied warranty of
  ~ MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  ~ GNU Affero General Public License for more details.
  ~
  ~ You should have received a copy of the GNU Affero General Public License
  ~ along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<div
    [id]="id()"
    class="tw:clear-both tw:inline-block tw:h-auto tw:min-h-[2.3rem] tw:w-full tw:mt-4 tw:pl-4 tw:bg-contrast-default tw:[&>span]:text-contrast-darkest tw:[&>span]:text-[1.3rem] tw:[&>span]:tracking-[0.1rem] tw:[&>span]:leading-4"
>
    <span class="tw:italic">
        <ng-content select="[kibBisherLabel]">{{
            'DV_BISHER_LABEL' | translate
        }}</ng-content>
    </span>

    <span>
        <ng-content select="[kibBisherValue]" />
    </span>
</div>
